import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import BlogsTableContainer from "../TableContainer";
import formatMessage from "../../../helpers/formatMessage";
import { fetchNewslettersData } from "../../../redux/newsletter/index";
import { fetchContactsData } from "../../../redux/contacts";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";

export default () => {
  const newslettersData = useSelector((state) => state.newslettersGlobalStore);
  const contactsMessage = useSelector(store => store.contactsGloalStore);
  console.log(contactsMessage.data.data, "these are the data that we have");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dataState, setDataState] = useState({
    formattedContactsMessage: [],
    authorRecords: [],
    currentPage: 0,
  });

  useEffect(() => {
    dispatch(fetchNewslettersData(dataState.currentPage));
    dispatch(fetchContactsData(dataState.currentPage));
  }, [dataState.currentPage]);

  let formattedContactsMessage = [];

  useEffect(() => {
    for (const message of contactsMessage.data.data || []) {
      console.log(message,"message");
      formattedContactsMessage.push(formatMessage(message));
    }

    setDataState({ ...dataState, formattedContactsMessage });
  }, [contactsMessage.data]);
  console.log(formattedContactsMessage, dataState, "these are your messages");

  const onPageChange = (pageNumber) =>
    setDataState((prevState) => ({ ...prevState, currentPage: pageNumber }));

  return (
    <div>
      {contactsMessage.loading && !contactsMessage.data[0] ? (
        <Loading />
      ) : (
        <>
          <BlogsTableContainer
            noAvatar
            headCells={[
              { id: "message", rightAlign: false, label: "Messages" },
              { id: "first name", rightAlign: true, label: "First Name" },
              { id: "last name", rightAlign: true, label: "Last Name" },
              { id: "email", rightAlign: true, label: "Email" },
              { id: "postDate", rightAlign: true, label: "Sent At" },
            ]}
            isUpdating={contactsMessage.loading && contactsMessage.data[0]}
            formattedData={dataState.formattedContactsMessage}
            hidden={["category"]}
            title="Messages"
            pagination={contactsMessage.data.pagination || {}}  
            onPageChange={onPageChange}
          />
        </>
      )}
    </div>
  );
};
